/**
 * WordPress dependencies
 */

/**
 * External dependencies
 */

/**
 * Inner dependencies.
 */
import { default as InspectorInterface } from '../../interface/Inspector/index.js';
import './inspector/tabs';

const Inspector = ( props ) => {
	return <InspectorInterface hookPrefix="info-box" { ...props } />;
};

export default Inspector;
